import useApi from '../hook/useApi';

const usePlacesApi = () => {
    const { sendRequest, loading, data, error } = useApi();

    const searchCities = async (query, page = 1, limit = 10) => {
        return sendRequest(`/booking/places/get?search=${encodeURIComponent(query)}&page=${page}&limit=${limit}`, 'GET', {});
    };

    const getPlacesForBooking = async (query, page = 1, limit = 10) => {
        return sendRequest(`/booking/places/get_places_for_create_booking?search=${encodeURIComponent(query)}&page=${page}&limit=${limit}`, 'GET', {});
    };

    const addCity = async (payload, userToken) => {
        const headers = {
            'x_auth_token': userToken
        };
        return sendRequest('/imp/user_screen/booking_property/create_user_booking_property', 'POST', payload, true, headers);
    };

    const deleteCity = async (cityId, userToken) => {
        const headers = {
            'x_auth_token': userToken
        };
        return sendRequest(`/booking/booking_property/delete/${cityId}`, 'DELETE', {}, true, headers);
    };

    return {
        searchCities,
        getPlacesForBooking,
        addCity,
        deleteCity,
        loading,
        data,
        error
    };
};

export default usePlacesApi;
